import { BaseBlockModel } from './ecd-block-models';
import { ECDNavigationLink } from './epi-model';

export enum PageType {
    NotFoundPage = 'NotFoundPage',
    EcdContentPage = 'ECDContentPage',
    EcdRootPage = 'ECDRootPage',
}
export interface BasePageModel {
    pageType: string | PageType;
    pageTitle: string;
}

export interface EcdRootPage extends BasePageModel {
    headerTitle: string;
    footer: string;
    navigationLinks: ECDNavigationLink[];
    clergySettingId?: string;
    parishSettingId?: string;
    requiredFormat?: string;
    mailSettingId?: string;
    mobileLogoImage?: string;
    mobileLogoImageAltText?: string;
    mobileLogoImageLink?: string;
    mobileMenuTriggerText: string;
}

export interface EcdNotFoundPage extends BasePageModel {
    mainContent: string;
}

export interface EcdContentPage extends BasePageModel {
    mainContent: string;
    contentArea: BaseBlockModel[];
}
